import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { WtfShortcutsComponent } from './shortcuts.component';
import { CoreCommonModule } from '../../utils/modules/core/modules/core-common.module';

@NgModule({
    declarations: [
        WtfShortcutsComponent
    ],
    imports     : [
        CoreCommonModule,
        RouterModule
    ],
    exports     : [
        WtfShortcutsComponent
    ]
})
export class WtfShortcutsModule
{
}
